export default __webpack_public_path__ + "static/media/Email.68187719.svg";